var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23 15V12.7316L14.564 7.28447C14.6627 7.19551 14.7643 7.13051 14.869 7.08945C14.9737 7.04839 15.0787 7.02718 15.184 7.02581C15.2987 7.02581 15.4113 7.04771 15.522 7.0915C15.6327 7.13598 15.733 7.20236 15.823 7.29063L16.748 8.25956C16.83 8.36083 16.8927 8.46621 16.936 8.57569C16.9787 8.68449 17 8.79363 17 8.90312C17 9.0126 16.9827 9.12277 16.948 9.23362C16.9133 9.34447 16.8467 9.45054 16.748 9.55181L11.44 15H9.23ZM0 13.5794V11.8889C0 11.4654 0.12 11.0692 0.36 10.7004C0.600667 10.3309 0.924 10.0441 1.33 9.84023C2.274 9.37561 3.21867 9.02731 4.164 8.79535C5.10867 8.56269 6.054 8.44637 7 8.44637C7.45 8.44637 7.90133 8.47511 8.354 8.53258C8.80667 8.59006 9.26233 8.67149 9.721 8.77687L6.846 11.7073V13.5794H0ZM15.19 9.88437L16.115 8.90312L15.191 7.93419L14.241 8.90928L15.19 9.88437ZM7 6.15747C6.17533 6.15747 5.469 5.8557 4.881 5.25217C4.293 4.64864 3.99933 3.924 4 3.07824C4.00067 2.23247 4.29433 1.50714 4.881 0.902244C5.46767 0.297346 6.174 -0.00339251 7 2.88642e-05C7.826 0.00345023 8.53233 0.30453 9.119 0.90327C9.70567 1.50201 9.99933 2.22734 10 3.07926C10.0007 3.93118 9.707 4.65583 9.119 5.2532C8.531 5.85057 7.82467 6.15131 7 6.15747Z",
    fill: "#2B6FAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.194b99071c9c3204316ff9bdb312b5b7.svg";
export { ForwardRef as ReactComponent };